import { render } from "./CulturePicker.vue?vue&type=template&id=da903b8e"
import script from "./CulturePicker.vue?vue&type=script&lang=ts"
export * from "./CulturePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script